import Vue from "vue";

export const CARD_READER_STATES = {
  CONNECTING: "connecting",
  READY: "ready",
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
  ERROR: "error",
};

export const cardReaderStatus = new Vue({
  data() {
    return {
      state: CARD_READER_STATES.CONNECTING,
      port: "",
      deviceName: "",
    };
  },
  methods: {
    setConnecting() {
      this.state = CARD_READER_STATES.CONNECTING;
    },
    setReady() {
      this.state = CARD_READER_STATES.READY;
      this.port = "";
      this.deviceName = "";
    },
    setConnected({ port = "", deviceName = "" } = {}) {
      this.state = CARD_READER_STATES.CONNECTED;
      this.port = port;
      this.deviceName = deviceName;
    },
    setDisconnected() {
      this.state = CARD_READER_STATES.DISCONNECTED;
      this.port = "";
      this.deviceName = "";
      localStorage.removeItem("cardreader");
    },
    setDeviceDisconnected() {
      this.state = CARD_READER_STATES.READY;
      this.port = "";
      this.deviceName = "";
      localStorage.removeItem("cardreader");
    },
    setError() {
      this.state = CARD_READER_STATES.ERROR;
      this.port = "";
      this.deviceName = "";
    },
  },
});
